import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { detailedBookFormatMap, bookCoversMap } from "../Utilities/mapUtil";

export default function SummaryItemBookDefaultDetails(props) {
  const languageContext = useContext(LanguageContext);
  const detailedBookFormat = detailedBookFormatMap.get(props.item.format);
  const detailedBookFormatArray = detailedBookFormat.split(" ");

  return (
    <>
      {props.item.format !== undefined && (
        <div
          className="position_flex_rtl"
          style={{ paddingBottom: "0.25rem" }}
        >
          <div>
            {detailedBookFormatArray
              .map((format) => languageContext.getTranslation(format))
              .join(", ")}
          </div>
        </div>
      )}
      {props.item.cover !== undefined && (
        <div
          className="position_flex_rtl"
          style={{ paddingBottom: "0.25rem" }}
        >
          <div>
            {[
              languageContext.getTranslation(appConst.COVER),
              languageContext.getTranslation(
                bookCoversMap.get(props.item.cover)
              ),
            ].join(" ")}
          </div>
        </div>
      )}
      {props.item.is_english !== undefined && (
        <div
          className="position_flex_rtl"
          style={{ paddingBottom: "0.25rem" }}
        >
          <div>
            {[
              languageContext.getTranslation(appConst.OPENING),
              props.item.is_english,
            ].join(" ")}
          </div>
        </div>
      )}
      {props.item.pages !== undefined && (
        <div className="position_flex_rtl">
          <div>
            {[
              props.item.pages,
              languageContext.getTranslation(appConst.PAGES),
            ].join(" ")}
          </div>
        </div>
      )}
    </>
  );
}
